"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20015ToJSON = exports.InlineResponse20015FromJSONTyped = exports.InlineResponse20015FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineResponse20015FromJSON(json) {
    return InlineResponse20015FromJSONTyped(json, false);
}
exports.InlineResponse20015FromJSON = InlineResponse20015FromJSON;
function InlineResponse20015FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'itsaCheckmateAccess': json['itsaCheckmateAccess'],
        'locationId': !(0, runtime_1.exists)(json, 'locationId') ? undefined : json['locationId'],
    };
}
exports.InlineResponse20015FromJSONTyped = InlineResponse20015FromJSONTyped;
function InlineResponse20015ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'itsaCheckmateAccess': value.itsaCheckmateAccess,
        'locationId': value.locationId,
    };
}
exports.InlineResponse20015ToJSON = InlineResponse20015ToJSON;
